/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Rut_S2Inputs */

const en_mk_tut_rut_s2 = /** @type {(inputs: Mk_Tut_Rut_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the agent that runs it, write the instruction, then set the schedule — every day at 09:00 Jakarta time, say.`)
};

const id_mk_tut_rut_s2 = /** @type {(inputs: Mk_Tut_Rut_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih agen yang mengerjakan, tulis instruksinya, lalu tentukan jadwal — misalnya setiap hari pukul 09.00 waktu Jakarta.`)
};

/**
* | output |
* | --- |
* | "Choose the agent that runs it, write the instruction, then set the schedule — every day at 09:00 Jakarta time, say." |
*
* @param {Mk_Tut_Rut_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_rut_s2 = /** @type {((inputs?: Mk_Tut_Rut_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Rut_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_rut_s2(inputs)
	return en_mk_tut_rut_s2(inputs)
});